import { Mic, Phone, Mail, MessageCircle } from "lucide-react";
import { useApp } from "@/context/AppContext";
import { VOICE_LANGS } from "@/lib/speech";

export default function SupportPage() {
  const { t, lang, catalog, setAssistantOpen, voiceLang, setVoiceLang } = useApp();
  return (
    <div className="space-y-5 px-4 pt-4" data-testid="support-page">
      <h1 className="text-2xl font-bold">{t("support")}</h1>
      <button data-testid="support-open-assistant-btn" onClick={() => setAssistantOpen(true)}
        className="flex w-full items-center gap-4 rounded-3xl bg-gradient-to-br from-[#8A1538] to-[#4a0b1f] p-5 text-start text-white shadow-lg transition-transform hover:scale-[1.01]">
        <span className="flex h-14 w-14 items-center justify-center rounded-full bg-[#B8901F]"><Mic size={24} /></span>
        <span><span className="block text-lg font-bold">{t("assistant")}</span><span className="text-xs text-white/75">ASR → AI → TTS · 12 languages</span></span>
      </button>
      <section>
        <h2 className="mb-2 text-base font-bold">{t("helpTitle")}</h2>
        <ul className="space-y-2">
          {(catalog?.voice_intents || []).map((i) => (
            <li key={i.intent} className="rounded-xl border bg-card p-3 text-sm shadow-sm">
              <p className="font-semibold">“{lang === "ar" ? i.example_ar : i.example_en}”</p>
              <p className="text-[11px] text-muted-foreground">{i.action}</p>
            </li>
          ))}
        </ul>
      </section>
      <section>
        <h2 className="mb-2 text-base font-bold">{t("voiceLanguage")}</h2>
        <div className="grid grid-cols-2 gap-2">
          {VOICE_LANGS.map((l) => (
            <button key={l.code} data-testid={`support-voice-lang-${l.code}`} onClick={() => setVoiceLang(l.code)}
              className={`rounded-xl border-2 p-2.5 text-start text-xs ${voiceLang === l.code ? "border-primary bg-[hsl(var(--maroon-soft))]" : "border-border bg-card"}`}>
              <span className="block text-sm font-semibold">{l.name}</span>
              <span className="text-muted-foreground">{t("quality")}: {l.quality}</span>
            </button>
          ))}
        </div>
      </section>
      <section className="grid grid-cols-3 gap-2 text-center text-xs">
        {[[Phone, "109 (simulated)"], [Mail, "support@qatarone.sandbox"], [MessageCircle, "WhatsApp (simulated)"]].map(([Icon, l]) => (
          <div key={l} className="rounded-xl border bg-card p-3"><Icon size={18} className="mx-auto mb-1 text-primary" /> <span className="break-all">{l}</span></div>
        ))}
      </section>
    </div>
  );
}
